import { render } from "./PageJadwalTestKognitif.vue?vue&type=template&id=b45409d6"
import script from "./PageJadwalTestKognitif.vue?vue&type=script&lang=js"
export * from "./PageJadwalTestKognitif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__